import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { ExposedCreateInvoicePensionIncreaseReq } from 'app/interfaces/requests/Exposed/exposedCreateInvoicePensionIncreaseReq';
import { ErrorItem } from 'app/interfaces/support/status/errorItem';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';

export interface DialogPensionIncreaseClaimsCreateResultsData {
    numberOfTotalClaims: number;
    numberOfSuccessfullyCreatedInvoices: number;
    failedClaimInvoiceRequests: {
        req: ExposedCreateInvoicePensionIncreaseReq;
        error: ErrorItem;
    }[];
}

@Component({
    selector: 'dialog-pension-increase-claims-create-results',
    templateUrl: 'dialog-pension-increase-claims-create-results.component.html',
    styleUrls: ['dialog-pension-increase-claims-create-results.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogPensionIncreaseClaimsCreateResults extends DialogGeneral {
    constructor(
        public matDialogRef: MatDialogRef<DialogPensionIncreaseClaimsCreateResults>,
        public dialogRef: MatDialogRef<DialogPensionIncreaseClaimsCreateResults>,
        public dialog: MatDialog,
        public lsrauthService: LsrauthService,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogPensionIncreaseClaimsCreateResultsData
    ) {
        super(dialogRef);
    }

    // Generates a CSV string from the results data
    generateResultCSV(): string {
        const rows = [
            ['Niðurstöður fyrir stofnun og sendingu reikninga'],
            [''],
            ['Fjöldi færsla sem átti að stofna reikning fyrir:', this.data.numberOfTotalClaims],
            ['Fjöldi reikninga sem stofnuðust og voru sendir í BC:', this.data.numberOfSuccessfullyCreatedInvoices],
            ['Fjöldi reikninga sem lentu á villu:', this.data.failedClaimInvoiceRequests?.length ?? 0],
        ];

        if (this.data.failedClaimInvoiceRequests && this.data.failedClaimInvoiceRequests.length > 0) {
            rows.push(['']);
            rows.push(['SSN', 'Claim ID', 'Villuskilaboð']);

            this.data.failedClaimInvoiceRequests.forEach((item) => {
                rows.push([formatKennitala(item.req.Ssn), item.req.ClaimId, item.error.message]);
            });
        }

        return rows.map((row) => row.join(',')).join('\n');
    }

    saveCSVFile() {
        const csv = this.generateResultCSV();
        const blob = new Blob(['\uFEFF' + csv], {
            type: 'text/csv;charset=utf-8;',
        });
        const url = URL.createObjectURL(blob);

        const today = new Date();

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Lifeyrishaekkanir-${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}.csv`);
        link.click();

        URL.revokeObjectURL(url);
    }
}
